/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetArtistsQueryVariables = Types.Exact<{
  offset: Types.InputMaybe<Types.Scalars['Int']>;
  limit: Types.InputMaybe<Types.Scalars['Int']>;
  name: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetArtistsQuery = { __typename: 'Query', getArtists: { __typename: 'ArtistsResponse', total: string | null, artists: Array<{ __typename: 'Artist', id: string | null, name: string | null, facebook_id: string | null, label_id: string | null, gfk_id: number | null, bio: string | null, gps_status: string | null, opus_id: string | null, created_at: string | null, social_media_kpi_facebook: number | null, social_media_kpi_instagram: number | null, social_media_kpi_twitter: number | null, campaigns: Array<{ __typename: 'Campaign', id: string | null, name: string | null, label_id: string | null }> | null }> } };


export const GetArtistsDocument = gql`
    query getArtists($offset: Int, $limit: Int, $name: String) {
  getArtists(limit: $limit, offset: $offset, name: $name) {
    artists {
      id
      name
      facebook_id
      label_id
      gfk_id
      bio
      gps_status
      opus_id
      created_at
      social_media_kpi_facebook
      social_media_kpi_instagram
      social_media_kpi_twitter
      campaigns {
        id
        name
        label_id
      }
    }
    total
  }
}
    `;

/**
 * __useGetArtistsQuery__
 *
 * To run a query within a React component, call `useGetArtistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtistsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetArtistsQuery(baseOptions?: Apollo.QueryHookOptions<GetArtistsQuery, GetArtistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArtistsQuery, GetArtistsQueryVariables>(GetArtistsDocument, options);
      }
export function useGetArtistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtistsQuery, GetArtistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArtistsQuery, GetArtistsQueryVariables>(GetArtistsDocument, options);
        }
export type GetArtistsQueryHookResult = ReturnType<typeof useGetArtistsQuery>;
export type GetArtistsLazyQueryHookResult = ReturnType<typeof useGetArtistsLazyQuery>;